'use client';

import { Dialog as MuiDialog } from '@mui/material';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Dispatch, FC, forwardRef, ReactNode, SetStateAction } from 'react';

const Transition = forwardRef(
	(
		props: TransitionProps & {
			children: React.ReactElement<any, any>;
		},
		ref: React.Ref<unknown>,
	) => <Slide direction='up' ref={ref} {...props} />,
);

interface DialogProps {
	showDialog: ReactNode | null;
	setShowDialog: Dispatch<SetStateAction<ReactNode | null>>;
}

export const Dialog: FC<DialogProps> = ({ showDialog, setShowDialog }) => {
	const closeDialog = (__: any, reason: string) => {
		if (reason && reason === 'backdropClick') {
			return;
		}
		setShowDialog(null);
	};
	return (
		<MuiDialog
			PaperProps={{
				className: 'pca__main-modal',
			}}
			maxWidth='xl'
			TransitionComponent={Transition}
			open={!!showDialog}
			onClose={closeDialog}
		>
			{showDialog}
		</MuiDialog>
	);
};
